import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/usage' },
    { path: '/login', name: 'login', component: () => import('@/pages/LoginPage.vue') },
    {
      path: '/usage',
      name: 'usage',
      component: () => import('@/pages/UsagePage.vue'),
      meta: { requiresAuth: true },
    },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/pages/NotFoundPage.vue') },
  ],
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  if (!auth.initialized) {
    await auth.bootstrap();
  }
  if (to.meta.requiresAuth && !auth.user) {
    return { name: 'login', query: { next: to.fullPath } };
  }
  if (to.name === 'login' && auth.user) {
    return { name: 'usage' };
  }
  return true;
});
